export default {
  name: 'fxCrm',
  component: () =>
    import(/* webpackChunkName: "fxCrm-layout" */ '@/modules/fxCrm/layouts/FxCrmLayout.vue'),
  redirect: '/fxCrm/fxHome',
  children: [
    {
      path: 'fxHome',
      name: 'fx-home',
      component: () => import(/* webpackChunkName: "fx-home" */ '@/modules/fxCrm/pages/FxHome.vue'),
    },
    {
      path: 'fxCompany/:id/',
      name: 'fx-company-detail',
      component: () =>
        import(
          /* webpackChunkName: "fx-company-detail" */ '@/modules/fxCrm/components/company/Detail.vue'
        ),
      props: (route) => {
        return {
          id: route.params.id,
        };
      },
    },
    {
      path: 'fxCompany',
      name: 'fx-company',
      component: () =>
        import(/* webpackChunkName: "fx-company" */ '@/modules/fxCrm/pages/FxCompany.vue'),
    },
    {
      path: 'fxAgenda',
      name: 'fx-agenda',
      component: () =>
        import(/* webpackChunkName: "fx-agenda" */ '@/modules/fxCrm/pages/FxAgenda.vue'),
    },
    {
      path: 'fxInteraction',
      name: 'fx-interaction',
      component: () =>
        import(/* webpackChunkName: "fx-interaction" */ '@/modules/fxCrm/pages/FxInteraction.vue'),
    },
    {
      // Vista desacoplada de las interacciones sin gestionar: dejó de ser una
      // pestaña del listado general para tener su propia consulta y, más
      // adelante, sus propios filtros y acciones.
      path: 'fxInteractionNoManagement',
      name: 'fx-interaction-no-management',
      component: () =>
        import(
          /* webpackChunkName: "fx-interaction-no-management" */ '@/modules/fxCrm/pages/FxInteractionNoManagement.vue'
        ),
    },
    {
      // Bandeja: solicitudes sin responsable, antes de la antesala. Mismos dos
      // roles que el panel de equipo (ver `ROUTE_ACCESS` en access-map.js).
      path: 'fxInbox',
      name: 'fx-inbox',
      component: () =>
        import(/* webpackChunkName: "fx-inbox" */ '@/modules/fxCrm/pages/FxInbox.vue'),
    },
    {
      // Solicitudes de aprobación (Aprobaciones, task_2). Solo ADMINISTRADOR CRM
      // y COORDINADOR CRM: el rol se controla en `src/router/access-map.js`.
      path: 'fxApprovals',
      name: 'fx-approvals',
      component: () =>
        import(/* webpackChunkName: "fx-approvals" */ '@/modules/fxCrm/pages/FxApprovals.vue'),
    },
    {
      // Historial de interacciones (FC-671/FC-673): los tres roles. El backend
      // recorta el alcance; el acceso está en `ROUTE_ACCESS` (access-map.js).
      path: 'fxInteractionHistory',
      name: 'fx-interaction-history',
      component: () =>
        import(
          /* webpackChunkName: "fx-interaction-history" */ '@/modules/fxCrm/pages/FxInteractionHistory.vue'
        ),
    },
    {
      // Panel de totalización por persona. Solo ADMINISTRADOR CRM y COORDINADOR
      // CRM: el rol se controla en `src/router/access-map.js` (ROUTE_ACCESS),
      // que es la fuente única, no aquí.
      path: 'fxTeamPanel',
      name: 'fx-team-panel',
      component: () =>
        import(/* webpackChunkName: "fx-team-panel" */ '@/modules/fxCrm/pages/FxTeamPanel.vue'),
    },
    {
      path: 'fxInteractionWpp',
      name: 'fx-interaction-wpp',
      component: () =>
        import(
          /* webpackChunkName: "fx-interaction-wpp" */ '@/modules/fxCrm/pages/FxInteractionWpp.vue'
        ),
    },
    {
      path: 'fxInteraction/:id/',
      name: 'fx-interaction-detail',
      component: () =>
        import(
          /* webpackChunkName: "fx-interaction-detail" */ '@/modules/fxCrm/components/interaction/Detail.vue'
        ),
      props: (route) => {
        return {
          id: route.params.id,
        };
      },
    },
    {
      path: 'fxInteraction/status/:id/',
      name: 'fx-interaction-status',
      component: () =>
        import(
          /* webpackChunkName: "fx-interaction-detail" */ '@/modules/fxCrm/pages/FxInteraction.vue'
        ),
      props: (route) => {
        return {
          id: route.params.id,
        };
      },
    },
    {
      path: 'fxPerson',
      name: 'fx-person',
      component: () =>
        import(/* webpackChunkName: "fx-person" */ '@/modules/fxCrm/pages/FxPerson.vue'),
    },
    {
      path: 'fxPerson/:id/',
      name: 'fx-person-detail',
      component: () =>
        import(
          /* webpackChunkName: "fx-person-detail" */ '@/modules/fxCrm/components/person/Detail.vue'
        ),
      props: (route) => {
        return {
          id: route.params.id,
        };
      },
    },
    {
      path: 'fxLead',
      name: 'fx-lead',
      component: () => import(/* webpackChunkName: "fx-lead" */ '@/modules/fxCrm/pages/FxLead.vue'),
    },
    {
      path: 'fxProspecto',
      name: 'fx-prospecto',
      component: () =>
        import(/* webpackChunkName: "fx-prospecto" */ '@/modules/fxCrm/pages/FxProspecto.vue'),
    },
    {
      path: 'fxBusiness',
      name: 'fx-business',
      component: () =>
        import(/* webpackChunkName: "fx-business" */ '@/modules/fxCrm/pages/FxBusiness.vue'),
    },
    {
      path: 'fxBusinessByPhase',
      name: 'fx-businessByPhase',
      component: () =>
        import(
          /* webpackChunkName: "fx-businessByPhase" */ '@/modules/fxCrm/pages/FxBusinessPhase.vue'
        ),
    },
    {
      path: 'fxSales',
      name: 'fx-sales',
      component: () =>
        import(/* webpackChunkName: "fx-sales" */ '@/modules/fxCrm/pages/FxSales.vue'),
    },
    {
      path: 'fxBusiness/:id/',
      name: 'fx-business-detail',
      component: () =>
        import(
          /* webpackChunkName: "fx-business-detail" */ '@/modules/fxCrm/components/business/Detail.vue'
        ),
      props: (route) => {
        return {
          id: route.params.id,
        };
      },
    },
    {
      path: 'itxByStatus',
      name: 'fx-itxByStatus',
      component: () =>
        import(
          /* webpackChunkName: "fx-itxByStatus" */ '@/modules/fxCrm/pages/ItxByStatusCanva.vue'
        ),
    },
    {
      path: 'itxByPhase/:statusName?/:id?',
      name: 'fx-itxByPhase',
      component: () =>
        import(/* webpackChunkName: "fx-itxByPhase" */ '@/modules/fxCrm/pages/ItxByPhaseCanva.vue'),
      props: (route) => {
        return {
          id: route.params.id,
          statusName: route.params.statusName,
        };
      },
    },
    {
      path: 'itxByStage/:statusName?/:idStatus?/:phaseName/:id?',
      name: 'fx-itxByStage',
      component: () =>
        import(/* webpackChunkName: "fx-itxByStage" */ '@/modules/fxCrm/pages/ItxByStageCanva.vue'),
      props: (route) => {
        return {
          id: route.params.id,
          statusName: route.params.statusName,
          phaseName: route.params.phaseName,
          idStatus: route.params.idStatus,
        };
      },
    },
    {
      path: 'itxByTraceability/:id?',
      name: 'fx-itxByTraceability',
      component: () =>
        import(
          /* webpackChunkName: "fx-itxByTraceability" */ '@/modules/fxCrm/pages/ItxByTraceability.vue'
        ),
      props: (route) => {
        return {
          id: route.params.id,
        };
      },
    },
    {
      path: 'fxInteractionStatus',
      name: 'fx-interactionStatus',
      component: () =>
        import(
          /* webpackChunkName: "fx-interactionStatus" */ '@/modules/fxCrm/pages/configuraciones/FxInteractionStatus.vue'
        ),
    },
    // Origen y Mi catálogo viven ahora como tabs de "Configuraciones generales"
    // (ver `fx-config-general` más abajo). La ruta suelta se conserva como
    // redirect para no romper enlaces ni marcadores.
    {
      path: 'fxOrigin',
      name: 'fx-origin',
      redirect: { name: 'fx-config-general', params: { tab: 'origen' } },
    },
    {
      path: 'fxNeed',
      name: 'fx-need',
      redirect: { name: 'fx-config-general', params: { tab: 'catalogo' } },
    },
    // Negocio perdido nace como tab; la ruta suelta es su `legacyRoute`.
    {
      path: 'fxLostReason',
      name: 'fx-lostReason',
      redirect: { name: 'fx-config-general', params: { tab: 'perdida' } },
    },
    // Sector también nace como tab; la ruta suelta es su `legacyRoute`.
    {
      path: 'fxSector',
      name: 'fx-sector',
      redirect: { name: 'fx-config-general', params: { tab: 'sector' } },
    },
    {
      path: 'fxCampaign',
      name: 'fx-campaign',
      component: () =>
        import(
          /* webpackChunkName: "fx-campaign" */ '@/modules/fxCrm/pages/configuraciones/FxCampaign.vue'
        ),
    },
    {
      path: 'fxTransactions',
      name: 'fx-transactions',
      component: () =>
        import(
          /* webpackChunkName: "fx-transactions" */ '@/modules/fxCrm/pages/configuraciones/Transactions.vue'
        ),
    },
    // La ruta legacy `fx-phase` (path 'fxPhase', FxPhases.vue / BusinessPhase)
    // se quitó: compartía path con `fx-fxPhase` y, al entrar sin id, la tapaba.
    //
    // Línea de negocio vieja: todo se configura en `fx-businessLineHome`. La
    // ruta se conserva como redirect para no romper enlaces ni marcadores.
    {
      path: 'fxBusinessLine',
      name: 'fx-businessLine',
      redirect: { name: 'fx-businessLineHome' },
    },
    // Vista de Línea de negocio (la que abre el submenú de Configuraciones).
    {
      path: 'fxBusinessLineHome',
      name: 'fx-businessLineHome',
      component: () =>
        import(
          /* webpackChunkName: "fx-businessLineHome" */ '@/modules/fxCrm/pages/configuraciones/FxBusinessLineHome.vue'
        ),
    },
    // Tab de "Configuraciones generales"; la ruta suelta queda como redirect.
    {
      path: 'fxZone',
      name: 'fx-zone',
      redirect: { name: 'fx-config-general', params: { tab: 'zonas' } },
    },
    {
      path: 'fxBulkUpload',
      name: 'fx-fxBulkUpload',
      component: () =>
        import(
          /* webpackChunkName: "fx-fxBulkUpload" */ '@/modules/fxCrm/pages/configuraciones/BulkUpload.vue'
        ),
    },
    {
      path: 'fxRules',
      name: 'fx-rules',
      component: () =>
        import(
          /* webpackChunkName: "fx-rules" */ '@/modules/fxCrm/pages/configuraciones/Rules.vue'
        ),
    },
    {
      path: 'fxFormula',
      name: 'fx-formula',
      // Tab de "Configuraciones del sistema"; la ruta suelta queda como redirect.
      redirect: { name: 'fx-config-system', params: { tab: 'formulas' } },
    },
    {
      path: 'fqIntegration',
      name: 'fx-fqIntegration',
      component: () =>
        import(
          /* webpackChunkName: "fx-fqIntegration" */ '@/modules/fxCrm/pages/configuraciones/FqIntegration.vue'
        ),
    },
    {
      path: 'fxUsersAdmin',
      name: 'fx-fxUsersAdmin',
      component: () =>
        import(
          /* webpackChunkName: "fx-fxUsersAdmin" */ '@/modules/fxCrm/pages/configuraciones/UsersAdmin.vue'
        ),
    },
    // Grupos: el equipo (coordinador + comerciales). Vive aparte de
    // "Administrar usuarios", que reparte roles; acá se arma la jerarquía.
    // Es un tab de "Configuraciones generales"; la ruta suelta queda como redirect.
    {
      path: 'fxGroups',
      name: 'fx-fxGroups',
      redirect: { name: 'fx-config-general', params: { tab: 'grupos' } },
    },
    {
      path: 'fxReports',
      name: 'fx-reports',
      component: () =>
        import(
          /* webpackChunkName: "fx-reports" */ '@/modules/fxCrm/pages/configuraciones/FxReports.vue'
        ),
    },
    {
      path: 'fxVarType',
      name: 'fx-varType',
      component: () =>
        import(
          /* webpackChunkName: "fx-varType" */ '@/modules/fxCrm/pages/configuraciones/FxVarType.vue'
        ),
    },
    // Variables, Estados, Fases, Etapas, Opciones de retoma y Causas de
    // descarte se configuran en Línea de negocio (`fx-businessLineHome`). Sus
    // páginas sueltas duplicaban esa edición con reglas distintas; las rutas se
    // conservan como redirect para no romper enlaces ni marcadores. Los
    // archivos (FxVariables, FxStatus, FxPhase, FxStage, FxRetoma,
    // FxDiscardReason) siguen en el repo, sin ruta.
    {
      path: 'fxVariable',
      name: 'fx-variable',
      redirect: { name: 'fx-businessLineHome' },
    },
    {
      path: 'fxStatus',
      name: 'fx-fxStatus',
      redirect: { name: 'fx-businessLineHome' },
    },
    {
      path: 'fxPhase/:id?',
      name: 'fx-fxPhase',
      redirect: { name: 'fx-businessLineHome' },
    },
    {
      path: 'fxStage/:id?',
      name: 'fx-fxStage',
      redirect: { name: 'fx-businessLineHome' },
    },
    {
      path: 'fxRetoma',
      name: 'fx-fxRetoma',
      redirect: { name: 'fx-businessLineHome' },
    },
    {
      path: 'fxDiscardReason',
      name: 'fx-fxDiscardReason',
      redirect: { name: 'fx-businessLineHome' },
    },
    // Moneda y Tipificación: tabs de "Configuraciones generales". Cuenta de
    // correo: tab de "Configuraciones del sistema". Las rutas sueltas quedan
    // como redirect.
    {
      path: 'fxCurrency',
      name: 'fx-currency',
      redirect: { name: 'fx-config-general', params: { tab: 'moneda' } },
    },
    {
      path: 'fxTipificacion',
      name: 'fx-tipificacion',
      redirect: { name: 'fx-config-general', params: { tab: 'tipificacion' } },
    },
    {
      path: 'fxEmailAccount',
      name: 'fx-emailAccount',
      redirect: { name: 'fx-config-system', params: { tab: 'correo' } },
    },
    {
      // Acceso restringido a ADMINISTRADOR CRM vía ROUTE_ACCESS (src/router/access-map.js),
      // igual que el resto de sub-rutas de configuración de fxCrm.
      path: 'fxFexiaSuggestions',
      name: 'fx-fxFexiaSuggestions',
      component: () =>
        import(
          /* webpackChunkName: "fx-fxFexiaSuggestions" */ '@/modules/fxCrm/pages/configuraciones/FxFexiaSuggestions.vue'
        ),
    },
    // Tokens de acceso y Creación de formulario: tabs de "Configuraciones del
    // sistema". Las rutas sueltas quedan como redirect.
    {
      path: 'fxAccessTokens',
      name: 'fx-fxAccessTokens',
      redirect: { name: 'fx-config-system', params: { tab: 'tokens' } },
    },
    {
      path: 'fxFormBuilder',
      name: 'fx-fxFormBuilder',
      redirect: { name: 'fx-config-system', params: { tab: 'formularios' } },
    },
    // Secciones de Configuración con tabs internos. Cada tab monta una página de
    // configuración existente, sin cambios (catálogo en helpers/configSections.js).
    // Sin `:tab`, o con uno que no existe, FxConfigSection abre el primero.
    {
      path: 'configuracion/general/:tab?',
      name: 'fx-config-general',
      component: () =>
        import(
          /* webpackChunkName: "fx-configSection" */ '@/modules/fxCrm/pages/configuraciones/FxConfigSection.vue'
        ),
      props: (route) => ({ sectionKey: 'general', tab: route.params.tab }),
    },
    {
      path: 'configuracion/sistema/:tab?',
      name: 'fx-config-system',
      component: () =>
        import(
          /* webpackChunkName: "fx-configSection" */ '@/modules/fxCrm/pages/configuraciones/FxConfigSection.vue'
        ),
      props: (route) => ({ sectionKey: 'system', tab: route.params.tab }),
    },

    {
      path: 'reportsList',
      name: 'fxReport-reportsList',
      component: () =>
        import(
          /* webpackChunkName: "fxReport-reportsList" */ '@/modules/reportesFxCrm/pages/ReportsList.vue'
        ),
    },
    {
      path: 'reportDetail/:id?',
      name: 'fxReport-reportDetail',
      component: () =>
        import(
          /* webpackChunkName: "fxReport-reportDetail" */ '@/modules/reportesFxCrm/pages/ReportDetail.vue'
        ),
      props: (route) => {
        return {
          id: route.params.id,
        };
      },  
    },
    {
      path: 'interactionByStatus',
      name: 'fxReport-interactionByStatus',
      component: () =>
        import(
          /* webpackChunkName: "fxReport-interactionByStatus" */ '@/modules/reportesFxCrm/pages/InteractionByStatus.vue'
        ),
    },
    {
      path: 'generalSales',
      name: 'fxReport-generalSales',
      component: () =>
        import(
          /* webpackChunkName: "fxReport-generalSales" */ '@/modules/reportesFxCrm/pages/GeneralSales.vue'
        ),
    },
    {
      path: 'generalManagement1',
      name: 'fxReport-generalManagement1',
      component: () =>
        import(
          /* webpackChunkName: "fxReport-generalManagement1" */ '@/modules/reportesFxCrm/pages/GeneralManagement1.vue'
        ),
    },
    {
      path: 'generalManagement2',
      name: 'fxReport-generalManagement2',
      component: () =>
        import(
          /* webpackChunkName: "fxReport-generalManagement2" */ '@/modules/reportesFxCrm/pages/GeneralManagement2.vue'
        ),
    },
    {
      path: 'generalCoordinator1',
      name: 'fxReport-generalCoordinator1',
      component: () =>
        import(
          /* webpackChunkName: "fxReport-generalCoordinator1" */ '@/modules/reportesFxCrm/pages/GeneralCoordinator1.vue'
        ),
    },
    {
      path: 'generalCoordinator2',
      name: 'fxReport-generalCoordinator2',
      component: () =>
        import(
          /* webpackChunkName: "fxReport-generalCoordinator2" */ '@/modules/reportesFxCrm/pages/GeneralCoordinator2.vue'
        ),
    },
  ],
};
